import { render, staticRenderFns } from "./DeleteSpecifiedReportModal.vue?vue&type=template&id=36dfd451&scoped=true&"
import script from "./DeleteSpecifiedReportModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteSpecifiedReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteSpecifiedReportModal.vue?vue&type=style&index=0&id=36dfd451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dfd451",
  null
  
)

export default component.exports